const env = window._env_ || {};

const config = {
  BASE_URL:
    env.ADMIN_API_BASE_URL ||
    process.env.REACT_APP_ADMIN_API_BASE_URL ||
    process.env.ADMIN_API_BASE_URL,
  S3_BUCKET_FOLDER: env.REACT_APP_S3_BUCKET_FOLDER || process.env.REACT_APP_S3_BUCKET_FOLDER,
  INVENTORY_ACCESS_ENABLED: (env.REACT_APP_INVENTORY_ACCESS_ENABLED ?? process.env.REACT_APP_INVENTORY_ACCESS_ENABLED) === 'true',
};

export default config;
